import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { OPERATION_ERRORS, UnitOperationsState } from 'src/app/models/unit-operations-state.model';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-operations-start-date-status',
  templateUrl: './operations-start-date-status.html',
  styleUrl: './operations-start-date-status.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperationsStartDateStatus {
  iconsService = inject(IconsService);
  state = input.required<UnitOperationsState>();
  startOperationsDate = computed(() => this.state().startDate);
  errorsList = computed(() => this.state().errors.map(error =>
    OPERATION_ERRORS[error] || 'Requisito pendiente de validación'
  ));
  graceLabel = computed(() => {
    const errors = this.state().errors;
    const meter = errors.includes('GAS_METER_ON_GRACE_PERIOD');
    const tank = errors.includes('TANK_ON_GRACE_PERIOD');
    if (meter && tank) return 'Medidor y Tanque sin requisitos cumplidos en tiempo de gracia';
    if (meter) return OPERATION_ERRORS['GAS_METER_ON_GRACE_PERIOD'];
    if (tank) return OPERATION_ERRORS['TANK_ON_GRACE_PERIOD'];
    return '';
  });
  status = computed(() => {
    switch (this.state().status) {
      case 'started': return 'success';
      case 'ready': return 'warning';
      case 'blocked': return this.graceLabel() ? 'grace' : 'error';
      default: return this.state().status;
    }
  });
}
